<modal-placeholder>
  <div class="interstitial__container">
    <div class="interstitial__close d-flex justify-content-end align-items-center gap-2" (click)="close()">
      <span>Close</span>
      <span><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="15" fill="#FBEA0C" />
          <line x1="20.215" y1="10.5309" x2="10.4377" y2="20.1213" stroke="black" stroke-width="1.95652" />
          <line x1="20.1213" y1="20.2147" x2="10.5309" y2="10.4375" stroke="black" stroke-width="1.95652" />
        </svg>
      </span>
    </div>
    <div class="interstitial__text-container mx-auto">
      <div class="interstitial__title text-center">
        <h3>Usted esta abandonando</h3>
      </div>
      <div class="interstitial__text text-center">
        <p>Está abandonando Screenfortype1.com y será dirigido a un sitio controlado y mantenido por un tercero. Sanofi
          no es responsable del contenido de los sitios web de terceros vinculados, ni de ninguna información educativa
          o de atención médica proporcionada en ellos.</p>
        <p>Sanofi no recibe ninguno de sus datos personales que puedan recopilarse en este sitio, y no es responsable
          del uso de la información personal por parte de los propietarios del sitio vinculado ni de la idoneidad de su
          Política de privacidad.</p>
        <p>Los profesionales de la salud que están disponibles en estos sitios web son independientes y ejercerán un
          juicio clínico autónomo al evaluar cualquier condición médica y las decisiones de atención resultantes.</p>
        <p>Al hacer clic en continuar, podrá acceder a un proveedor de telesalud independiente y cumplir con los
          términos y condiciones del sitio web o servicio.</p>
      </div>
    </div>
    <div class="interstitial__buttons d-flex justify-content-center gap-3">
      <div class="interstitial__back d-flex justify-content-center align-items-center gap-2" (click)="close()">
        <span>
          <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.292893 6.79289C-0.0976311 7.18342 -0.0976311 7.81658 0.292893 8.20711L6.65685 14.5711C7.04738 14.9616 7.68054 14.9616 8.07107 14.5711C8.46159 14.1805 8.46159 13.5474 8.07107 13.1569L2.41421 7.5L8.07107 1.84315C8.46159 1.45262 8.46159 0.819457 8.07107 0.428932C7.68054 0.0384078 7.04738 0.0384078 6.65685 0.428932L0.292893 6.79289ZM1 8.5H18.5071V6.5H1V8.5Z"
              fill="#1D1D1D" />
          </svg>
        </span>
        <span>Regresar</span>
      </div>
      <div class="interstitial__continue d-flex justify-content-center align-items-center gap-2"
        (click)="continue(url)">
        <span>Continuar</span>
        <span>
          <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18.2142 8.20711C18.6048 7.81658 18.6048 7.18342 18.2142 6.79289L11.8503 0.428932C11.4598 0.0384078 10.8266 0.0384078 10.4361 0.428932C10.0455 0.819457 10.0455 1.45262 10.4361 1.84315L16.0929 7.5L10.4361 13.1569C10.0455 13.5474 10.0455 14.1805 10.4361 14.5711C10.8266 14.9616 11.4598 14.9616 11.8503 14.5711L18.2142 8.20711ZM0 8.5H17.5071V6.5H0L0 8.5Z"
              fill="white" />
          </svg>
        </span>
      </div>
    </div>
  </div>
</modal-placeholder>